import { Box, Typography, Link } from '@mui/material';
import React from 'react';
import Icon from '@mdi/react';
import { mdiHomeOutline, mdiHelpCircleOutline, mdiInformationOutline } from '@mdi/js';
import useBreakpoints from '../../../../hooks/useBreakpoint';
import { useTranslation } from 'react-i18next';

const noVulnerabilitiesInfoCardSx: React.CSSProperties = {
    margin: 'auto',
    maxWidth: '500px',
    border: '1px solid #D5E3E7',
    padding: '20px',
    borderRadius: '4px',
    color: '#245A6D',
    boxShadow: '0px 2px 6px 2px #00000026',
};

export default () => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'noVulnerabilitiesInfo' });

    const { isMobile } = useBreakpoints();

    return (
        <>
            <Box
                style={{
                    ...noVulnerabilitiesInfoCardSx,
                    ...(isMobile && { marginLeft: '20px', marginRight: '20px' }),
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Icon path={mdiInformationOutline} style={{ height: '28px', width: '28px' }} />
                    <Typography variant='h5' sx={{ ml: 1.25 }}>
                        {t('noVulnerabilities')}
                    </Typography>
                </Box>

                <br />

                <Typography sx={{ fontWeight: 'bold' }}>{t('noVulnerabilitiesText')}</Typography>

                <br />

                <Link
                    href='https://support.thinkproject.com/hc/de/categories/4413035104017'
                    color='inherit'
                    display='flex'
                    flexDirection='row'
                    target='_blank'
                    rel='noopener'
                    sx={{ '&:hover': { color: '#3591A9' } }}
                >
                    <Icon path={mdiHelpCircleOutline} size={1} />
                    <Typography variant='body1' sx={{ ml: 1 }}>
                        EPLASS Support
                    </Typography>
                </Link>

                <br />

                <Link
                    href='https://app.eplass.de/'
                    color='inherit'
                    display='flex'
                    flexDirection='row'
                    sx={{ '&:hover': { color: '#3591A9' } }}
                >
                    <Icon path={mdiHomeOutline} size={1} />
                    <Typography variant='body1' sx={{ ml: 1 }}>
                        {t('backToWebClient')}
                    </Typography>
                </Link>
            </Box>
        </>
    );
};
